import type { HTMLAttributes } from 'react';
import { useThemeImage } from '../../providers/ThemeProvider';
import logo from './logo.svg';
import smallLogo from './small_logo.svg';

export const SmallLogo: React.FC<HTMLAttributes<HTMLImageElement>> = props => {
  // docusaurus tsc thinks this is a react component, but it's not, and it's not using it
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  const smallLogoUrl = useThemeImage(smallLogo as unknown as string);
  return <img alt="lemonade logo" height="21" width="16" {...props} src={smallLogoUrl} />;
};

export const Logo: React.FC<HTMLAttributes<HTMLImageElement>> = props => {
  // docusaurus tsc thinks this is a react component, but it's not, and it's not using it
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  const logoUrl = useThemeImage(logo as unknown as string);
  return <img alt="lemonade logo" {...props} src={logoUrl} />;
};
